import { Validators } from '@angular/forms';
import { CustomValidator } from '../../../../firstmac-material-lib/projects/fmc-elements/src/lib/common';
import { defaultFieldConfig } from '../../../../firstmac-material-lib/projects/fmc-elements/src/lib/common';

export class CustomerDetailsModel {
  name = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      CustomValidator.nameValidator(defaultFieldConfig.fullName)
    ])
  };
  email = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.email
    ])
  };
  phone = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };
}
